import * as Config from '../../../config';
import React from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import dayjs from 'dayjs';

// import Button from '../common/Button';
import DelayButton from '../common/DelayButton';
import Card from '../common/Card';
import ListV2 from '../content/list/ListV2';

import usePlaylist from '../../../hooks/usePlaylist';

function ConnectedPlaylistRoom({
  id, title, allowSaving = false, sortable = false,
  width, height, store, style, isOnline, isWatcher,
  listType = 'Full'
}) {
  let playlist = (store && store.get) ? store.get(id) : null;
  const {
    beginDrag,
    copyLocalToAPI
  } = usePlaylist(playlist);

  const images = (playlist && playlist.tracks.length > 0) ? [...playlist.tracks.map( x => (x && x.img) ? x.img : Config.DEFAULT_IMG )] : [Config.DEFAULT_IMG];

  return (playlist && isOnline) ? (
    <div id={`C-${id}`} className={`flexColumn playlist-page scrolling`} style={{ ...style }}>
      <div className={`flexRow card-container-playlist scrolling`}>
        <Card
          images={images}
          audio={{
            id: playlist.id,
            name: playlist.name,
            tracks: playlist.track_count,
            extra: null
          }}
          dragEnabled={true}
          playEnabled={true}
          beginDrag={beginDrag}
          type={`PLAYLIST`}
          style={{width: Config.PLAYLIST_COVER_SIZE }}
          ooWidth={Config.PLAYLIST_COVER_SIZE}
        />
        <div className={`playlist-infos`}>
          <p className={`playlist-title type-title`}>{Config.camelCase(title)}</p>
          <p className={`playlist-p type-small`}>
            { `Created on ${dayjs().format(`YYYY/MM/DD`)}`}
            {` • `}{playlist ? playlist.track_count : 0} Tracks
          </p>
          { allowSaving && <DelayButton
              label={'Save playlist'}
              classNameEnable={`playlist-button ${Config.ACRONYME}`}
              classNameDisable={`playlist-button ${Config.ACRONYME} disable`}
              style={{ marginTop: 20, right: -30 }}
              onClick={copyLocalToAPI}
          />}
        </div>
      </div>

      <div className={`content-container`} style={{ width }} >
        <ListV2
          id={playlist.id}
          data={ playlist.tracks }
          pathApi={null}
          sortable={ false /* !isWatcher || sortable */ }
          width={width}
          height={height - 8}
          size={Config.LIST_ROW_HEIGHT}
          style={{ marginTop: 8 }}
          filtersStyle={{ display: `none`, top: 0, right: 0 }}
          panelStyle={{ margin: `6px 0px 19px 0px` }}
          filters={[`track_name`, `artists_s`, `remixers_s`, `label`, `genre_s`, `bpm`, `key`]}
          type={listType}
          enableKeys={false}
          enableShortcuts={false}
          orderBy={[`release`, `title`, `remixers_s`, `label`, `genre_s`, `key_camelot`, `bpm`, `artists_s`]}
          isBoost={false}
          automix={false}
          from={`shared-playlist`}
          isLoadMore={false}
        />
      </div>
    </div>
  ) : null;
}

ConnectedPlaylistRoom.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  isOnline: PropTypes.bool.isRequired,
  listType: PropTypes.string
}

const PlaylistRoom = connect(
  state => ({
    width: state.dimension.width,
    height: state.dimension.height - 105,
    store: state.storePlaylists,
    isOnline: (!!state.inRoomPM && state.enablePM),
    isWatcher: state.isWatcherPM
  })
)(ConnectedPlaylistRoom);

export default PlaylistRoom;
